module.exports = __webpack_public_path__ + "static/img/four.0bad6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/2/four.png
// module id = 38Wy
// module chunks = 1